import type {
  GuildRankTitle,
  GuildSpecialTitle,
} from "@/core/guild-members/titles"

export type Profile = {
  memberId: string
  displayName: string | null
  avatarUrl: string | null
  joinedAt: string | null
  rankTitle: GuildRankTitle | null
  specialTitles: GuildSpecialTitle[]
  activityPoints: Array<{ year: number; month: number; points: number }>
}

export const profileApi = {
  get: async (): Promise<Profile> => {
    const response = await fetch("/api/profile", {
      method: "GET",
      credentials: "include",
    })

    if (!response.ok) {
      throw new Error("Failed to load profile")
    }

    const payload = (await response.json()) as { profile: Profile }
    return payload.profile
  },
}
